import { render, staticRenderFns } from "./QuoteFormTreatmentsTable.vue?vue&type=template&id=705cce64&scoped=true&"
import script from "./QuoteFormTreatmentsTable.vue?vue&type=script&lang=js&"
export * from "./QuoteFormTreatmentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705cce64",
  null
  
)

export default component.exports